import { render, staticRenderFns } from "./field-stopwatch.vue?vue&type=template&id=b815965c&scoped=true&"
import script from "./field-stopwatch.vue?vue&type=script&lang=js&"
export * from "./field-stopwatch.vue?vue&type=script&lang=js&"
import style0 from "./field-stopwatch.vue?vue&type=style&index=0&id=b815965c&prod&lang=scss&"
import style1 from "./field-stopwatch.vue?vue&type=style&index=1&id=b815965c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b815965c",
  null
  
)

export default component.exports